import { IError } from '@unfoldrtech/portal-mic'
import { AxiosResponse, AxiosError } from 'axios'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { coreAPI } from '../services/coreAPI'
import firebaseAuth from '../services/firebaseAuth'
import { generateCorrelationId } from '../utils/helpers'

type TLogoutMutationResult = UseMutationResult<
  AxiosResponse<void>,
  AxiosError<IError>,
  void
>

export default function useLogout() {
  return useMutation([`logout`], () =>
    coreAPI
      .misc({ accessToken: firebaseAuth.getIdToken() })
      .logout(generateCorrelationId())
  ) as TLogoutMutationResult
}
